import { useMutation } from "@tanstack/react-query";
import { getToken } from "../../services/token.service";

export const useCreateTokenMutation = () =>
  useMutation({
    mutationFn: getToken,
  });